import { hasPermission } from "../../../../shared/components/layout/sidebar/utils/permissions.js";

export const VIEW_SALE_INTEGRATIONS_ROLE = "Visualizar Integrações Venda";

/** Decide se o usuário pode ver a coluna Integrações da lista de vendas. */
export function canShowSaleIntegrationsColumn(permissions) {
  return hasPermission(permissions, VIEW_SALE_INTEGRATIONS_ROLE, "islist");
}
